import { useEffect, forwardRef, useState } from 'react';
import * as S from './styled';

export const Menu = forwardRef((props, ref) => {
    const {
        anchorEl,
        children,
        ...rest
    } = props;
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [openUp, setOpenUp] = useState(false);

    useEffect(() => {
        if (!anchorEl) return;
        const { current } = ref;
        const { left, bottom, top, height } = anchorEl.getBoundingClientRect();
        
        requestAnimationFrame(() => {
            const menuHeight = current?.offsetHeight || 0;
            const windowHeight = window.innerHeight;

            if (bottom + menuHeight > windowHeight) {
                setOpenUp(true);
                setPosition({ top: top - menuHeight, left });
            } else {
                setOpenUp(false);
                setPosition({ top: bottom, left });
            }
            current.style.visibility = 'visible';
        });
    }, [anchorEl, ref]);

    if (!anchorEl) return null;

    return (
        <S.Container>
            <S.Options
                ref={ref}
                style={{
                    top: `${position.top}px`,
                    left: `${position.left}px`,
                    visibility: 'hidden',
                }}
                $openUp={openUp}
                {...rest}
            >
                {children}
            </S.Options>
        </S.Container>
    );
});
